import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
} from "@angular/core";
import { PaymentStatus } from "@bca-confirmation/models/_enums";
import { ITransaction } from "@bca-confirmation/models/transaction";
import * as confirmationActions from "@bca-confirmation/store/confirmation.actions";
import { AvoTrackingService } from "@bca-core/services/avo-tracking.service";
import * as receiptActions from "@bca-receipt/store/receipt.actions";
import { ICompany } from "@bca-shared/models/company";
import { IProduct } from "@bca-shared/models/product";
import { pageData } from "@bca-shared/shared.constants";
import { AvoService } from "@bca-shared/utils/avo/avo.service";
import * as appActions from "@bca-store/app.actions";
import { IAction } from "@bca-store/models/action";
import { createAction } from "@bca-store/models/action-creator";
import { IRootState } from "@bca-store/store.reducers";
import { selectAllProducts, selectTotalPrice, selectTotalProductCount } from "@bca-store/store.selectors";
import { select, Store } from "@ngrx/store";
import { Observable } from "rxjs";

@Component({
  selector: "bca-confirmation",
  templateUrl: "confirmation.component.html",
  styleUrls: ["confirmation.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationComponent implements OnInit {
  representativeEmail$: Observable<string>;
  statusPaymentLoading$: Observable<boolean>;
  hasPaymentFailed$: Observable<boolean>;
  isOpenPayment$: Observable<boolean>;
  transaction$: Observable<ITransaction>;
  company$: Observable<ICompany>;
  products$: Observable<IProduct[]>;
  totalProductCount$: Observable<number>;
  totalPrice$: Observable<number>;

  PaymentStatus = PaymentStatus;
  confirmationSteps = pageData;

  constructor(
    private store$: Store<IRootState>,
    private _avoService: AvoService,
    private _avoTrackingService: AvoTrackingService,
    private _store$: Store<IRootState>,
  ) {
    this.representativeEmail$ = this.store$.pipe(
      select(({ receipt }) => receipt.company?.representative?.email),
    );

    this.hasPaymentFailed$ = this.store$.pipe(
      select(({ confirmation }) => confirmation.paymentFailed),
    );

    this.company$ = this._store$.pipe(
      select(({ receipt }) => receipt.company),
    );

    this.products$ = this._store$.pipe(select(selectAllProducts));
    this.totalProductCount$ = this._store$.pipe(select(selectTotalProductCount));
    this.totalPrice$ = this._store$.pipe(select(selectTotalPrice));

    this.statusPaymentLoading$ = this._store$.pipe(
      select(({ confirmation }) => confirmation.statusPaymentLoading),
    );

    this.transaction$ = this._store$.pipe(
      select(({ confirmation }) => confirmation.transaction),
    );

    this.isOpenPayment$ = this._store$.pipe(
      select(({ confirmation }) => confirmation.transaction?.paymentStatus === PaymentStatus.Open),
    );

    this.initializeActions();
  }

  ngOnInit(): void {
    this.initializeActions();
  }

  retryPayment(): void {
    this.store$.dispatch(
      this.createAction(
        new receiptActions.SetCompletedStatus({ completed: false }),
      ),
    );
    this.store$.dispatch(
      this.createAction(new confirmationActions.SetTransaction(null)),
    );
    this.store$.dispatch(this.createAction(new appActions.PreviousRoute()));
  }

  ngOnDestroy(): void {
  }

  resetState(): void {
    this.triggerAvoButtonClick();
    this.store$.dispatch(this.createAction(new appActions.ResetState()));
  }

  private initializeActions(): void {
    this.store$.dispatch(
      this.createAction(new confirmationActions.StatusPayment()),
    );
    this.store$.dispatch(
      this.createAction(
        new confirmationActions.RedirectToIssuerLoading({ loading: false }),
      ),
    );
  }

  private triggerAvoButtonClick(): void {
    const props = {
      uniqueName: "confirmation_of_order",
      description: "thanksPage",
      clickDestination: "https://www.ns.nl/zakelijk",
      clickText: "Naar ns.nl/zakelijk",
      data: undefined,
    };

    const trackingData = this._avoTrackingService.trackButtonClick(props);

    this._avoService.buttonClick(trackingData);
  }

  private createAction(action: IAction): IAction {
    return createAction(action, ConfirmationComponent);
  }
}